import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import LoanTable from "../../../components/LoanTable/LoanTable";
import { Box } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import LoanReportsTable from "../../../components/LoanReportsTable/LoanReportsTable";

const InterestRevenueReport = ({startDate, endDate, duration, isCustomFilter}) => {
  let user = useSelector((state) => state.login);
  const [reportData, setReportData] = useState([]);

  useEffect(()=> {
    getReportData();
  },[duration, isCustomFilter]);

  const getReportData = async() => {
    try {
      const response = await commonRunQuery(311, `${startDate}/${endDate}`);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const reportsArray = Array.isArray(response?.data?.body?.record) ? response?.data?.body?.record : [response?.data?.body?.record];
        setReportData(reportsArray);
        console.log("getReportData==========",reportsArray);
      } else {
        setReportData([]);
      }
      console.log("InterestRevenueReport_getReportData---------------",response);
    } catch (error) {
      console.log("getReportData_error==========",error);
    }
  }

  const columns = [
    {
      label: 'Loan ID',
      getValue: (row) => row.li?.LoanID ?? ''
    },
    {
      label: 'Borrower Name',
      getValue: (row) => row.record?.BorrowerName?.toString().trim() ? row.record?.BorrowerName : "-"
    },
    {
      label: 'Regular Fees',
      getValue: (row) => row.li?.RegularFees ?? '',
      align: 'right',
      amount: true
    },
    {
        label: 'Late Fees',
        getValue: (row) => row.record?.LateFee ?? '',
        align: 'right',
        amount: true
    },
    {
        label: 'Total',
        getValue: (row) => row.record?.TotalPayable ?? '',
        align: 'right',
        amount: true
    }
  ];

  return (
    <Box>
      <LoanReportsTable 
        data={reportData} 
        columns={columns} 
        title="Interest Revenue Report" 
        formatRow={(row) => [
          row.li?.LoanID,
          row.record?.BorrowerName,
          row.li?.RegularFees,
          row.record?.LateFee,
          row.record?.TotalPayable,
        ]} 
        author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
      />
    </Box>
  )
}

export default InterestRevenueReport;
